<template>
  <div class="block" id="map_detail_buy_income_data">
    <h2 style="font-size: 24px">内购收益数据</h2>
    <div><slot name="Header"></slot></div>
    <title-name
      title=" "
      :btn="btnOptions"
      @selectChange="selectChange"
    ></title-name>
    <div class="content-inner-wrap">
      <div class="data-filter">
        <span v-if="productState.type === '3'" class="mgr25">迷你号</span>
        <el-input v-model="orderGoodsUin" class="mgr25" v-if="productState.type === '3'" style="width: 200px;" />
        <span class="mgr25">选择日期</span>
        <el-date-picker
          v-if="productState.type === '3'"
          v-model="month"
          type="month"
          align="left"
          value-format="yyyyMM"
          unlink-panels
          @change="DateChange"
        >
        </el-date-picker>
        <el-date-picker
          v-else
          v-model="ProductDate"
          type="daterange"
          align="left"
          unlink-panels
          range-separator="~"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="timestamp"
          :picker-options="pickerOptions"
          @change="DateChange"
        >
        </el-date-picker>
        <el-button @click="ProDetailBtnClicked" class="search_btn" type="info">
          查找
        </el-button>
        <span class="btnGroup" v-if="productState.type !== '3'">
          <el-radio-group v-model="dayNum" size="medium" @change="clickDate">
            <el-radio-button label="7"> 7天</el-radio-button>
            <el-radio-button label="30">30天 </el-radio-button>
            <el-radio-button label="90"> 90天</el-radio-button>
            <el-radio-button label="1" v-if="productState.type === '1'">
              昨天
            </el-radio-button>
          </el-radio-group>
        </span>
        <span class="download-wrap" @click="exportFn">
          <img src="@/assets/images/icon_export.png" />
          <span>导出数据</span>
        </span>
      </div>
      <!-- 添加筛选 -->
      <div class="screening">
        <div class="income-box">
          <span class="desc"> 货币类型</span>
          <!-- <Cascader
            :data="incomeOptions"
            v-model="screen_value"
            @on-change="DateChange"
          >
          </Cascader> -->
          <el-cascader
            v-if="productState.type !== '3'"
            :options="incomeOptions"
            @change="changeScreen"
            :show-all-levels="false"
            v-model="screen_value"
          >
          </el-cascader>
          <el-cascader
            v-else
            :options="orderGoodsOptions"
            @change="changeScreen"
            :show-all-levels="false"
            v-model="money_type"
          >
          </el-cascader>
        </div>
        <!-- <div class="source-box">
          <span class="desc"> 收入来源</span>
          <el-select v-model="source_value" placeholder="全部">
            <el-option
              v-for="item in sourceOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div> -->
      </div>
      <div class="data-table" v-loading="productDetailLoading">
        <template v-if="productState.type === '1'">
          <el-table :data="DetailData" stripe v-if="screen_value.length != 2">
            <el-table-column
              :align="item.align"
              :prop="item.prop"
              :label="item.label"
              :class-name="item.classname"
              v-for="(item, index) in productState.ProductDetailData"
              :key="index"
            >
            </el-table-column>
            <template slot="empty">
              <div class="img-no" v-if="showDefault">
                <img
                  class="img-no-data"
                  src="../../../assets/images/img_table_no_data.png"
                />
                <div class="noCart">暂无数据</div>
              </div>
            </template>
          </el-table>
          <el-table :data="DetailData" stripe v-else>
            <el-table-column
              align="center"
              prop="date"
              label="日期"
              class-name="tb-date"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="money_type"
              label="货币类型"
              class-name="tb-date"
            >
            </el-table-column>
            <!-- <el-table-column
              align="center"
              prop="date"
              label="收入来源"
              class-name="tb-date"
            >
            </el-table-column> -->
            <el-table-column
              align="center"
              prop="desc"
              label="广告收入类型"
              class-name="tb-desc"
            >
            </el-table-column>
            <!-- <el-table-column align="center" label="广告相关">
              <el-table-column
                align="center"
                prop="type"
                label="广告收入类型"
                class-name="tb-date"
              >
              </el-table-column>
              <el-table-column
                align="center"
                prop="name"
                label="广告名称"
                class-name="tb-date"
              >
              </el-table-column>
            </el-table-column> -->
            <el-table-column
              align="center"
              prop="num"
              label="数额"
              class-name="tb-num"
            >
            </el-table-column>
            <template slot="empty">
              <div class="img-no" v-if="showDefault">
                <img
                  class="img-no-data"
                  src="../../../assets/images/img_table_no_data.png"
                />
                <div class="noCart">暂无数据</div>
              </div>
            </template>
          </el-table>
        </template>
        <template v-else-if="productState.type === '2'">
          <tableDEtail
            :DetailData="DetailData"
            :screen_value="screen_value"
            :showDefault="showDefault"
          ></tableDEtail>
        </template>
        <!-- 订单查询 -->
        <template v-else>
          <orderGoodsDetail
            :DetailData="DetailData"
            :screen_value="screen_value"
            :showDefault="showDefault"
          ></orderGoodsDetail>
        </template>
      </div>
      <div class="data-filter-page">
        <el-pagination
          background
          layout="prev,pager,next,jumper"
          :total="ProductPageCount"
          @current-change="PaginationChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
const ONE_WEEK_TIME = 1000 * 60 * 60 * 24 * 7;
const ONE_DAY_TIME = 24 * 60 * 60 * 1000 - 1;
const ONE_DAY = 24 * 60 * 60 * 1000;
import { useProduct } from '../hook/useProduct';
import titleName from './title-btn.vue';
import tableDEtail from './table-detail.vue';
import orderGoodsDetail from './order-goods-detail.vue';
const btnOptions = [
  { label: '地图收益', id: '1' },
  { label: '商品收益', id: '2' },
  { label: '订单查询', id: '3' },
];
const selectOpt = [
  {
    label: '全部',
    value: 999,
  },
  {
    label: '迷你豆',
    value: 2,
  },
  {
    label: '迷你点',
    value: 4,
  },
  {
    label: '广告',
    value: 3,
    children: [
      {
        label: '广告-全部',
        value: 3,
      },
      {
        label: '触发器',
        value: 6,
      },
      {
        label: '广告内购',
        value: 7,
      },
      {
        label: '通行证',
        value: 8,
      },
      {
        label: '其他广告',
        value: 9,
      },
    ],
  },
  {
    label: '贡献点',
    value: 1,
  },
  {
    label: '其他收入',
    value: 5,
  },
];
export default {
  components: {
    titleName,
    tableDEtail,
    orderGoodsDetail,
  },
  data() {
    return {
      btnOptions,
      productDetailLoading: false,
      ProductPageCount: 0,
      DetailData: [],
      ProductDate: [],
      orderGoodsUin: '',
      screen_value: [999],
      source_value: 'all',
      money_type: 999,
      dayNum: 7,
      month: '',
      endTime: '',
      startTime: '',
      showDefault: false,
      productState: {},
      Pagination: {
        page_size: 10,
        page: 1,
      },
      sourceOptions: [
        {
          label: '全部',
          value: 'all',
        },
        {
          label: '地图',
          value: 'map',
        },
        {
          label: '资源',
          value: 'source',
        },
        {
          label: '其他',
          value: 'other',
        },
      ],
      incomeOptions: selectOpt,
      orderGoodsOptions: [
        {
          label: '迷你币',
          value: 1,
        },
        {
          label: '迷你豆',
          value: 2,
        },
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
    };
  },
  watch: {
    DetailData(val) {
      val.length ? (this.showDefault = false) : (this.showDefault = true);
    },
    'productState.type'(val) {
      if (val == 3) {
        // 订单查询
        this.money_type = 1;
        const date = new Date();
        const year = date.getFullYear();
        const month = date.getMonth() + 1;
        this.month = `${year}${month < 10 ? '0' + month : month}`;
      }
    },
  },
  props: {
    mapId: {
      type: String,
      default: '',
    },
  },
  created() {
    const { productState, productModel } = useProduct();
    this.productState = productState;
    this.productModel = productModel;
    const currTime = new Date(new Date(new Date()).toDateString()).getTime();
    this.ProductDate = [currTime - ONE_WEEK_TIME, currTime - ONE_DAY];
  },
  mounted() {
    this.getProductDetail();
    if (this.DetailData.length) {
      this.showDefault = false;
    } else {
      this.showDefault = true;
    }
  },
  methods: {
    async selectChange(val) {
      this.productModel.changeType(val);
      if (val == '3') {
        this.money_type = 1;
        this.DetailData = [];
        return;
      } else if (val == '2') {
        // 商品收益
        this.screen_value = [1];
        this.money_type = 1;
        this.incomeOptions = selectOpt.filter(f =>
          [1, 2, 3, 4].includes(f.value),
        );
        this.incomeOptions = this.incomeOptions.map(m => {
          if (m.value === 3) return { label: '广告', value: 3 };
          return m.value === 1 ? { label: '迷你币', value: 1 } : m;
        });
        if (this.dayNum == 1) {
          this.dayNum = 7;
          this.clickDate();
          return;
        }
      } else {
        this.screen_value = [999];
        this.money_type = 999;
        this.incomeOptions = selectOpt;
      }
      this.getProductDetail();
    },
    PaginationChange(currPage) {
      this.Pagination.page = currPage;
      this.getProductDetail();
    },
    clickDate() {
      const nowTime = new Date(new Date(new Date()).toDateString()).getTime();
      //判断选择时间是7天/30天/90天
      this.endTime =
        new Date(new Date(new Date()).toDateString()).getTime() - 1;
      this.ProductDate[1] = this.endTime - ONE_DAY_TIME;
      if (this.dayNum == 1) {
        this.startTime = nowTime - 24 * 60 * 60 * 1000;
      } else if (this.dayNum == 7) {
        this.startTime = nowTime - 7 * 24 * 60 * 60 * 1000;
      } else if (this.dayNum == 30) {
        this.startTime = nowTime - 30 * 24 * 60 * 60 * 1000;
      } else {
        this.startTime = nowTime - 90 * 24 * 60 * 60 * 1000;
      }
      this.ProductDate[0] = this.startTime;
      this.getProductDetail();
    },
    exportFn() {
      if (this.productState.type === '3' && !this.orderGoodsUin) {
        this.$message.error('请输入迷你号');
        return;
      }
      this.fetchExport();
    },
    DateChange() {},
    //导出收益明细数据
    async fetchExport() {
      let data = {
        start_time: parseInt(this.ProductDate[0] / 1000, 10),
        end_time: parseInt((this.ProductDate[1] + ONE_DAY_TIME) / 1000, 10),
        money_type: this.screen_value[0],
        id: this.mapId,
      };
      if (this.productState.type === '3') {
        data.money_type = this.money_type;
        data.buy_uin = this.orderGoodsUin;
        data.month = this.month ? this.month : this.filterMonth();
      }
      try {
        const res = await this.productState.exportApi(data);
        this.downloadFile(res.data.url);
        this.$message.success('下载成功');
      } catch (error) {
        console.log(error);
      }
    },
    changeScreen() {
      // if (this.screen_value.length === 1) {
      //   this.money_type = this.screen_value[0];
      // } else {
      //   this.money_type = this.screen_value[1];
      // }
      if (this.productState.type === '3' && !this.orderGoodsUin) {
        return;
      }
      this.getProductDetail();
    },
    //下载数据
    downloadFile(url) {
      let a = document.createElement('a');
      a.href = url;
      a.download = url.split('/').pop();
      a.click();
    },
    ProDetailBtnClicked() {
      this.getProductDetail();
    },
    filterMonth() {
      const date = new Date();
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      return `${year}${month < 10 ? '0' + month : month}`;
    },
    async getProductDetail() {
      if (this.productState.type === '3' && !this.orderGoodsUin) {
        this.$message.error('请输入迷你号');
        return;
      }
      let data = {
        id: this.mapId,
        start_time: parseInt(this.ProductDate[0] / 1000, 10),
        end_time: parseInt((this.ProductDate[1] + ONE_DAY_TIME) / 1000, 10),
        page_size: this.Pagination.page_size,
        page: this.Pagination.page,
        money_type: this.money_type,
      };
      if (this.productState.type === '3') {
        data.money_type =
          typeof this.money_type === 'object'
            ? this.money_type.toString()
            : this.money_type;
        data.buy_uin = this.orderGoodsUin;
        data.month = this.month ? this.month : this.filterMonth();
      }
      this.productDetailLoading = true;
      const res = await this.productState.queryApi(data);
      if (res.data.list.length) {
        this.DetailData = res.data.list.map(item => {
          if (item.desc === 6) {
            item.desc = '广告触发器';
          } else if (item.desc === 7) {
            item.desc = '广告内购';
          } else {
            item.desc = '广告通行证';
          }
          if (this.productState.type) {
            item.buy_num = 1;
          }
          // if (item.money_type === 999) {
          //   item.money_type = '全部';
          // } else if (item.money_type === 1) {
          //   item.money_type = '贡献点';
          // } else if (item.money_type === 2) {
          //   item.money_type = '迷你豆';
          // } else if (item.money_type === 3) {
          //   item.money_type = '广告';
          // } else if (item.money_type === 4) {
          //   item.money_type = '迷你点';
          // } else if (item.money_type === 5) {
          //   item.money_type = '其他';
          // } else if (item.money_type === 6) {
          //   item.money_type = '广告触发器';
          // } else if (item.money_type === 7) {
          //   item.money_type = '广告内购';
          // } else {
          //   item.money_type = '广告通行证';
          // }
          item.money_type = this.currenMoney(this.money_type);
          return item;
        });
      } else this.DetailData = res.data.list;

      this.ProductPageCount = +res.data.total_count;
      this.productDetailLoading = false;
    },
    currenMoney(moneyType) {
      let type = '';
      switch (moneyType) {
        case 999:
          type = '全部';
          break;
        case 1:
          if (this.productState.type === '1') {
            type = '贡献点';
          } else {
            type = '迷你币';
          }
          break;
        case 2:
          type = '迷你豆';
          break;
        case 3:
          type = '广告';
          break;
        case 4:
          type = '迷你点';
          break;
        case 5:
          type = '激励金';
          break;
        default:
          break;
      }
      return type;
    },
  },
};
</script>
<style lang="scss" scoped>
.block {
  margin-top: 80px;
  .content-inner-wrap {
    .data-filter {
      margin-bottom: 22px;
      .mgr25 {
        margin-right: 25px;
      }
      .el-radio-group {
        height: 40px;
        padding-bottom: 5px;
        margin-left: 10px;
        .el-radio-button.el-radio-button--medium {
          ::v-deep .el-radio-button__inner {
            height: 38px;
            padding-top: 12px;
          }
        }
      }
      .search_btn {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
        border-left: 0;
        color: #595959;
        border-right: 1px solid #d9d9d9;
        border-top: 1px solid #d9d9d9;
        border-bottom: 1px solid #d9d9d9;
        background-color: #f4f4f5;
      }
      .download-wrap {
        float: right;
        border-radius: 4px;
        font-size: 11px;
        // font-weight: 600;
        margin-top: 18px;
        display: flex;
        align-items: center;
        cursor: pointer;
        color: #2b6ddf;
        img {
          margin-right: 8px;
        }
      }
    }
    .screening {
      display: flex;
      margin: 10px auto;
      .income-box {
        margin-right: 20px;
        display: flex;
        flex-direction: row;
        align-items: center;
        .desc {
          margin-right: 25px;
        }
        ::v-deep .ivu-cascader-rel {
          width: 135px;
          .ivu-input {
            height: 36px;
          }
        }
        ::v-deep .ivu-cascader .ivu-cascader-menu-item {
          font-size: 14px !important;
        }
        ::v-deep .ivu-input.ivu-input-default {
          font-size: 14px;
        }
        ::v-deep .ivu-cascader-menu {
          .ivu-cascader-menu-item.ivu-cascader-menu-item-active {
            color: #fd9b21;
          }
        }
        .el-cascader {
          width: 115px;
          ::v-deep .el-input__inner {
            padding-left: 15px;
            height: 36px;
          }
        }
      }
      .source-box {
        .desc {
          margin-right: 10px;
        }
        .el-select {
          width: 84px;
          ::v-deep .el-input__inner {
            padding-left: 8px;
            height: 36px;
          }
        }
      }
    }
    .data-table {
      margin-top: 28px;
      border: 1px solid #d9d9d9;
      overflow: hidden;
      border-radius: 3px;
      ::v-deep .el-table tr:last-child td {
        border-bottom: none;
      }
      ::v-deep .el-table::before {
        background: transparent;
      }
      ::v-deep .el-table th {
        background: #fafafa;
        //line-height: 29px;
      }
      ::v-deep .el-table td {
        line-height: 29px;
        padding: 7px 0 6px;
      }
      .img-no {
        margin: 20px auto 10px auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .img-no-data-word {
          // margin: 10px auto;
        }
      }
    }
    .data-filter-page {
      margin-top: 44px;
      text-align: center;
      margin-bottom: 12px !important;
      ::v-deep .el-pagination.is-background .el-pager li,
      ::v-deep .el-pagination.is-background .btn-prev,
      ::v-deep .el-pagination.is-background .btn-next {
        width: 31px;
        height: 31px;
        border-radius: 4px;
        margin: 0 4.5px;
        background-color: #fff;
        color: #8c8c8c;
        border: 1px solid #d9d9d9;
      }
      ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #fffaed;
        color: #fd9b21;
        border-color: #ffc973;
      }
    }
  }
}
</style>
